import { createRouter, createWebHistory, createWebHashHistory, RouteRecordRaw } from "vue-router";
import { AuthRoutes } from '@/modules/auth/auth.routes';
import { DashboardRoutes } from '@/modules/dashboard/dashboard.routes';
import { GamesRoutes } from '@/modules/games/games.routes';
import { TokensRoutes } from '@/modules/tokens/tokens.routes';
import { AccountRoutes } from '@/modules/account/account.routes';
import { HomeRoutes } from '@/modules/home/home.routes';
import { LegalRoutes } from '@/modules/legal/legal.routes';

import 'vue-router'

declare module 'vue-router' {
  interface RouteMeta {
    title?: string
  }
}

const routes: RouteRecordRaw[] = [
  ...AuthRoutes,
  ...DashboardRoutes,
  ...GamesRoutes,
  ...TokensRoutes,
  ...AccountRoutes,
  ...HomeRoutes,
  ...LegalRoutes,
  {
    path: "/:catchAll(.*)",
    name: 'viewPageNotFound',
    meta: {title: 'Page not found'},
    component: () => import("@/modules/viewPageNotFound.vue"),
  }

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
